// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-e66777c8] .el-dialog__body{\n padding: 10px 20px !important;\n}\n.boxHtml[data-v-e66777c8]{\n  height: 500px;\n  overflow-y: auto;\n  border: 1px solid #8f8f8f;\n  padding: 0 10px;\n}\n.disabled-div[data-v-e66777c8] {\n  opacity: 0.6;  /* 通常还会降低透明度来表明该div不可交互 */\n  pointer-events: auto;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
